import { defineSagaForService } from '@repo/core'
import {
  addTrustDevice,
  deleteDeviceSigning,
  deleteDeviceTrusted,
  postDeviceSigning,
  refreshToken,
  updateDeviceAlias,
} from '@repo/user-services'
import {
  addTrustDeviceActions,
  deleteDeviceSigningDataActions,
  deleteDeviceTrustedDataActions,
  deviceSigningDataActions,
  refreshTokenDeviceActions,
  updateDeviceAliasActions,
} from '../../slices'

export const devicesMutationsServiceConfig = defineSagaForService({
  [deviceSigningDataActions.postRequest.type]: {
    apiClientDomain: 'user',
    service: postDeviceSigning,
    actionTypeResponse: deviceSigningDataActions.postResponse.type,
    actionTypeRequest: deviceSigningDataActions.postRequest.type,
  },
  [addTrustDeviceActions.postRequest.type]: {
    apiClientDomain: 'user',
    service: addTrustDevice,
    actionTypeResponse: addTrustDeviceActions.postResponse.type,
    actionTypeRequest: addTrustDeviceActions.postRequest.type,
    getParams: (params: any) => params,
  },
  [deleteDeviceSigningDataActions.deleteRequest.type]: {
    apiClientDomain: 'user',
    service: deleteDeviceSigning,
    actionTypeResponse: deleteDeviceSigningDataActions.deleteResponse.type,
    actionTypeRequest: deleteDeviceSigningDataActions.deleteRequest.type,
  },
  [deleteDeviceTrustedDataActions.deleteRequest.type]: {
    apiClientDomain: 'user',
    service: deleteDeviceTrusted,
    actionTypeResponse: deleteDeviceTrustedDataActions.deleteResponse.type,
    actionTypeRequest: deleteDeviceTrustedDataActions.deleteRequest.type,
  },
  [refreshTokenDeviceActions.postRequest.type]: {
    apiClientDomain: 'user',
    service: refreshToken,
    actionTypeResponse: refreshTokenDeviceActions.postResponse.type,
    actionTypeRequest: refreshTokenDeviceActions.postRequest.type,
  },
  [updateDeviceAliasActions.putRequest.type]: {
    apiClientDomain: 'user',
    service: updateDeviceAlias,
    actionTypeResponse: updateDeviceAliasActions.putResponse.type,
    actionTypeRequest: updateDeviceAliasActions.putRequest.type,
  },
})
